import Glide from '@glidejs/glide';

const initTestimonialsBlock = () => {
    let block = document.querySelector('.js-section-testimonials');

    if (!block) return;
    let gliderRoot = block.querySelector('.glide');
    if (!gliderRoot) return;

    let options = {
        type: 'carousel',
        perView: 4,
        autoplay: 0,
        animationDuration: 900,
        pauseOnHover: true,
        swipeThreshold: 40, //default 80, which is a bit too lazy
        dragThreshold: 60, //default 120, which is a bit too lazy
        touchAngle: 30,
        gap: 35,
        focusAt: 1,
        breakpoints: {
            1440: {
                autoplay: false,
                gap: 35,
                perView: 3,
                peek: { before: 0, after: 0 },
            },
            1023: {
                autoplay: false,
                gap: 35,
                perView: 1,
                peek: { before: 70, after: 70 },
                focusAt: 0,
            },
            500: {
                gap: 20,
                perView: 1,
                peek: { before: 40, after: 40 },
                focusAt: 0,
            },
        },
    };

    const glide = new Glide(gliderRoot, options);

    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted');
    });

    let left = block.querySelector('.js-left');
    let right = block.querySelector('.js-right');
    if (left) {
        left.addEventListener('click', () => {
            glide.go('<');
        });
    }
    if (right) {
        right.addEventListener('click', () => {
            glide.go('>');
        });
    }

    glide.mount();
};

export { initTestimonialsBlock };
